import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › Finance (leaf).
export const finance: ContentPage = {
  slug: "sales-enablement/finance",
  template: "hrmsFeature",
  seo: {
    title: "CRM Finance - Quotes, Invoices & Payments | GetBiz CRM",
    description: "Bridge sales and finance in GetBiz CRM. Manage quotes, invoices and payments alongside deals so nothing slips between closing and collecting.",
    keywords: ["crm finance", "sales invoicing", "quote to cash", "crm billing"],
    ogImage: "/assets/data/seoimages/finance.webp",
  },
  leaf: {
    hero: {
      caption: "Finance",
      title: "Connect Sales and Finance in One Flow",
      description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Finance",
      bullets: [
        { title: "Quote to Invoice", description: "Turn a won deal into an invoice in one click." },
        { title: "Payment Tracking", description: "See what is paid, due and overdue." },
        { title: "Unified Records", description: "Keep finance data on the same account." },
        { title: "Fewer Handoffs", description: "Cut the gap between sales and finance." },
      ],
      image: "/assets/images/img/product/crm/finance-lead-image.webp",
      imageAlt: "Finance — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "Finance connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Configure, Price, Quote (CPQ)", href: "/crm-software/sales-enablement/configure-price-quote/", description: "Configure products, apply the right pricing and generate professional quotes instantly.", image: "/assets/images/img/product/crm/configure-price-quote.webp", imageAlt: "GetBiz CRM configure, price, quote (cpq)" },
      { title: "Documents Library", href: "/crm-software/sales-enablement/documents-library/", description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.", image: "/assets/images/img/product/crm/documents-library.webp", imageAlt: "GetBiz CRM documents library" },
      { title: "Calendar", href: "/crm-software/sales-enablement/calendar/", description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.", image: "/assets/images/img/product/crm/calendar.webp", imageAlt: "GetBiz CRM calendar" },
      { title: "SalesInbox", href: "/crm-software/sales-enablement/salesinbox/", description: "Work email inside the CRM with full deal context beside every message.", image: "/assets/images/img/product/crm/salesInbox.webp", imageAlt: "GetBiz CRM salesinbox" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Finance in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-finance",
  },
  sections: [],
};
